import { useDirection, useProperty, useSnowplowTracking, useTranslation } from '@eti/providers';
import { Heading, Inline, Stack, Text } from '@etg/wings';
import { Share } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { PartOfExternalFlights } from '@eti/schema-types';
import { routes } from '../../../../../constants/routesAndApisConstants';
import TopicsContentWrapper from '../TopicsContentWrapper';
import CardWithActionButton from '../../common/CardWithActionButton';
import { useOrderDetails } from '../../../containers/OrderDetailsContext';
import FaqSection from '../../common/FaqSection';
import ContactRyanairContent from './ContactRyanairContent';

const AddServices = () => {
  const { t } = useTranslation();
  const { p } = useProperty();
  const { isRTL } = useDirection();
  const { isSnowplowTrackingEnabled, sendTrackEvent } = useSnowplowTracking();
  const { isEligibleToBuyExtraProducts, partOfExternalFlights, faqSectionPerSlug } =
    useOrderDetails();
  const faqSectionSlug = p('ContactUs.AddServices.Faq.Slug');

  if (partOfExternalFlights === PartOfExternalFlights.All) {
    return <ContactRyanairContent faqSectionSlug={faqSectionSlug} />;
  }

  const handleOnCardClick = () => {
    if (isSnowplowTrackingEnabled) {
      sendTrackEvent({
        category: 'Contact',
        action: 'Click',
        label: 'SEE_PRODUCTS',
        property: 'ADD_SERVICES',
      });
    }
  };

  return (
    <TopicsContentWrapper
      chatType="oriana"
      leftColumnContent={
        <Stack spacing={24}>
          {isEligibleToBuyExtraProducts ? (
            <Text asHtml>{t('ContactUs.Subtopic.AddServices.Content')}</Text>
          ) : (
            <Stack spacing={24}>
              <Text>{t('ContactUs.Subtopic.AddServices.NoExtraProducts.Content')}</Text>
              <a
                aria-label={`${t('ContactUs.Airlines.Button.Text')}, ${t(
                  'ScreenReader.Link.OpensInNewTab.AriaLabel.Text',
                )}`}
                data-testid="add-services-link-to-carriers"
                href="/rf/carriers"
                target="_blank"
              >
                <Inline alignY="center" spacing={8}>
                  <Text>{t('ContactUs.Airlines.Button.Text')}</Text>
                  <Share aria-hidden="true" mirrored={isRTL} size={20} />
                </Inline>
              </a>
            </Stack>
          )}
          {faqSectionPerSlug?.[faqSectionSlug] && (
            <FaqSection
              headingAs="h5"
              headingLevel={4}
              padding={0}
              section={faqSectionPerSlug[faqSectionSlug]}
            />
          )}
        </Stack>
      }
      rightColumnContent={
        isEligibleToBuyExtraProducts && (
          <CardWithActionButton
            as={Link}
            buttonText={t('ContactUs.Subtopic.AddServices.Banner.Button.Text')}
            onClick={handleOnCardClick}
            to={routes.ORDER_DETAILS_EXTRA_PRODUCTS}
          >
            <Stack spacing={8}>
              <Heading as="h5" level={3}>
                {t('ContactUs.Subtopic.AddServices.Banner.Title')}
              </Heading>
              <Text>{t('ContactUs.Subtopic.AddServices.Banner.Content')}</Text>
            </Stack>
          </CardWithActionButton>
        )
      }
      snowplowProperty="ADD_SERVICES"
    />
  );
};

export default AddServices;
